import { render } from "./WeatherAlerts.vue?vue&type=template&id=0b687be6"
import script from "./WeatherAlerts.vue?vue&type=script&lang=ts"
export * from "./WeatherAlerts.vue?vue&type=script&lang=ts"
script.render = render

export default script